export const SharePointInputTypes = {
    number: "Number",
    datetime: "datetime",
    currency: "Currency",
    note: "Note",
    text: "Text",
    Boolean: "Boolean",
    url: "URL",
    choice: "Choice",
    multiChoice: "MultiChoice",
    user: "User",
    userMulti: "UserMulti",
    taxonomyFieldType: "TaxonomyFieldType",
    taxonomyFieldTypeMulti: "TaxonomyFieldTypeMulti",
    numberPercentage: "NumberPercentage",
    lookupSingle: "Lookup",
    lookupMulti: "LookupMulti",
    thumbNail: "Thumbnail"
};

export const SharePointMetadataBooleans = {
    true: "TRUE",
    false: "FALSE"
}

export const SharePointFormatTypes = {
    dateOnly: "DateOnly",
    dateTime: "DateTime",
    image: "Image",
    hyperlink: "Hyperlink",
    dropdown: "Dropdown",
    radioButtons: "RadioButtons"
}

